/**
Github gist loading and saving. Github no longer allows saving anonymous gists
so this is only used for loading the previously saved ones.

Status: Legacy
*/


base := "https://api.github.com/gists"

export load := (gistId: string) ->
  // b60b30d55133c4073e8c1846b0b217f8
  fetch(`${base}/${gistId}`).then (data) ->
    data.json()
  .then (data) ->
    data = data.files["data.json"]?.content or data.files["pattern0.json"]?.content

    if data
      JSON.parse data
    else
      alert `Failed to load gist with id: ${gistId}`
